export default "__VITE_ASSET__BD826eVV__"